export function formatRatioAsPercent(
  ratio: number,
  options: Intl.NumberFormatOptions = {}
) {
  const safeRatio = Number.isFinite(ratio) ? ratio : 0
  return new Intl.NumberFormat('zh-CN', {
    style: 'percent',
    maximumFractionDigits: 0,
    ...options,
  }).format(safeRatio)
}

export function formatRatioAsPercentValue(
  ratio: number,
  options: Intl.NumberFormatOptions = {}
) {
  return formatRatioAsPercent(ratio, options).replace(/[%\s]/g, '')
}
